export default __webpack_public_path__ + "static/img2-1dbf26e0aec5e8d322caa87068fee140.png";